import { render, staticRenderFns } from "./PropertySearchNew.vue?vue&type=template&id=ec9c536a&scoped=true"
import script from "./PropertySearchNew.vue?vue&type=script&lang=js"
export * from "./PropertySearchNew.vue?vue&type=script&lang=js"
import style0 from "./PropertySearchNew.vue?vue&type=style&index=0&id=ec9c536a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9c536a",
  null
  
)

export default component.exports